export default __webpack_public_path__ + "static/public-welcome-5c4d8d95752a05cb11ec46590180d65e.webp";